export default function ($translate) {
    return {
        KEYS: {
            INDEPENDENT_SURVEY: 'INDEPENDENT_SURVEY',
            COURSE_SURVEY: 'COURSE_SURVEY'
        },
        LABELS: {
            INDEPENDENT_SURVEY: $translate.instant('survey.Independent survey'),
            COURSE_SURVEY: $translate.instant('survey.Course survey')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/survey/groupType/index.js